define(function () {
    const IpsModel = require('civicsBase/ipsModel');
    const utils = require('civicsUtils/general_utilities');

    return Backbone.Model.extend({
        urlRoot: '/delegate/civics-api/api/',
        instrumentUrls: {
            building: 'cdr/parentchildrelationships/Building/',
            businesslicense: 'cdr/parentchildrelationships/businesslicense/',
            codeenforcement: 'cdr/parentchildrelationships/CodeEnforcement/',
            planning: 'cdr/parentchildrelationships/Planning/',
            project: 'cdr/parentchildrelationships/Project/',
            tradelicense: 'cdr/parentchildrelationships/TradeLicense/',
            use: 'cdr/parentchildrelationships/Use/',
            servicerequest: '?????'
        },
        url: function () {
            var retVal = 'ERROR';
            if (this.instrumentType) {
                retVal = this.urlRoot + this.instrumentUrls[this.instrumentType.toLowerCase()];
                if(this.get('id')){
                    retVal+=this.get('id');
                }
            }
            return retVal;
        },
        parse:function(){
            
        }
    });
});